RivalIQ.apps.SocialPosts.module('views', function (views, App, Backbone, Marionette, $, _, s) {

    'use strict';

    views.BaseSummarizedTableWidget = RivalIQ.apps.Dashboard.widgets.SummarizedMetricTable.mixin({

        mixins: {
            LinksPosted: App.mixins.LinksPostedTableMixin
        },

        eventsNotToDebounce: {
            'click .x-sort': 'onSortClick',
            'click .table-expander': 'onExpanderClick',
            'click tbody tr': '_onRowClick'
        },

        widgetClassName: '',

        getFetchAttributes: function () {
            const me = this;

            let fetchAttributes = RivalIQ.apps.Dashboard.widgets.SummarizedMetricTable.prototype.getFetchAttributes.apply(me, arguments);

            if (me.sortAttrPrefix) {

                // The server will return just the expansions we need; in order to figure that out, it needs all
                // the sort columns so it can break ties the same way the table does.
                if (me.sendMultipleSortCols) {
                    const columns = me.metricsCollection.getColumnSortOrder(me.sortColumns);
                    fetchAttributes.orderBy = _.reduce(columns, function (memo, idx) {
                        if (_.isFinite(idx)) {
                            const metric = me.metricsCollection.at(idx);
                            const orderProperty = metric.get('orderProperty') || metric.get('property');

                            return memo.concat(orderProperty);
                        }

                        return memo;
                    }, []).join(',');
                }

                fetchAttributes = _.reduce(['limit', 'sortOrder', 'orderBy'], function (memo, attrName) {
                    memo[me.sortAttrPrefix + s.capitalize(attrName)] = fetchAttributes[attrName];
                    return memo;
                }, {});
            }

            return fetchAttributes;
        },

        className: function () {
            const me = this;
            const className = RivalIQ.apps.Dashboard.widgets.SummarizedMetricTable.prototype.className.apply(me, arguments);
            return [
                className,
                (me.getProp('dimension')) ? 'table-expandable' : '',
                me.widgetClassName
            ].join(' ');
        },

        getDefinitionModel: function (rowIndex, columnIndex, isSubCell) {
            const me = this;
            let coll = me.metricsCollection;
            const idx = (me.invert ? rowIndex : columnIndex);

            // In these tables, the first cell of a subcell row can have a View Posts eyeball.
            if (isSubCell && columnIndex === 0) {
                coll = me.dimensions;
            }

            return coll.at(idx);
        },

        loadData: function () {
            const me = this;

            const tableFetches = RivalIQ.apps.Dashboard.widgets.SummarizedMetricTable.prototype.loadData.apply(me, arguments);

            if (!me.dimensionViewMoreMetricProperty) {
                return tableFetches;
            }

            const dimensionViewMoreMetric = me.metric.build({
                property: me.dimensionViewMoreMetricProperty
            });

            return $.when(dimensionViewMoreMetric.fetch(), tableFetches)
                .done(function (viewMoreData) {
                    me.viewMoreData = _(viewMoreData.getValue())
                        .keyBy(_.head)
                        .mapValues(_.last)
                        .value();
                });
        },

        getDimensionViewMoreData: function (rowIndex, rowValues, dimensionRows) {
            const me = this;

            const domainValue = rowValues[0][0];
            const numRowsShown = dimensionRows.length;
            const numTotalRows = _.get(me, ['viewMoreData', domainValue]);

            if (!numTotalRows) {
                return;
            }

            const numRowsOutstanding = Number(numTotalRows) - numRowsShown;

            if (numRowsOutstanding > 0) {

                let viewModeLink = '';

                if (!me.dashboardModel.isFocus()) {
                    viewModeLink = $.tagHtml('a', {
                        href: me.dashboardModel.viewMorePath({
                            rowExpansions: `(id:${domainValue.replace('.', '%2E')})`
                        }),
                        html: `${me.dimensionViewMoreLinkName} <span class="fa fa-angle-double-right"></span>`
                    });
                }

                return {
                    message: `...and ${numRowsOutstanding} more. ${viewModeLink}`
                };
            }
        }
    });

}, window.s);
